require("@babel/polyfill");
require("./page.scss");

(function ($) {
    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });
})(jQuery);